import React from "react";
import styled from "styled-components";
import I10n from '../../features/i10n';
import MsxIcons from '../../features/msx-icons';
import PropTypes from 'prop-types';
import BomLicenceGroup from "../bill_of_material_licence_group";
import BomServicePlanGroup from "./bill_of_materials_service_plan_group";
import { logCSVEvent } from "../../utils/analytics-logger";
import { download } from "../../utils/download";
import DynamicLabel from "../../atoms/dynamic-label";
import ProductInformationCache from '../../persistence/description-cache';
import { PRIMARY_COLOR } from "../../color-constants";

const LicenceWrapper = styled.div`
`;

const Container = styled.div`
  @media (max-width: 800px) {
    display: none;
  }
`;

const Header = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 10px;
`;

const Title = styled.h3`
  margin: 0px;
  font-size: 20px !important;
  font-weight: bold;
  color: #626469;
  margin-right: 10px;
  @media (max-width: 800px) {
    line-height: inherit;
  }
  white-space: nowrap;
`;

const Icon = styled.span`
  display: inline-block;
  margin-left: 10px;
  color: black;
  text-decoration: none !important;
`;

const ProductsAndIconWrapper = styled.div`
  display: flex;
  align-items: center;
  ${props => props.desktop && `justify-content: flex-end;
  flex: 5 1 0px;`}
`;

const AddToMyProductLabel = styled.span`
  white-space: nowrap;
  width: 100%;
`;

const AddToMyProductWrapper = styled.div`

  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});

  font-weight: 400;
  font-size: 12px;

  display: flex;
  align-items: center;

  ${props => props.favoritesDisabled ? `
    opacity: 0.5;
  ` : `
    cursor: pointer;
    :hover {
      ${AddToMyProductLabel} {
        text-decoration: underline;
      }
    }
  `}
`;

const TableWrapper = styled.table`
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  font-size: 12px;
`;

const TableLicenceGroupHeader = styled.thead`
  width: 100%;
`;

const TableLicenceGroupTitleRow = styled.tr``;

const TableLicenceGroupTitleCell = styled.td`
  background-color: #A0A4A8;
  color: white;
  width: 100%;
  vertical-align: middle;
`;

const LicencesTableBody = styled.tbody`
  position: relative;
`;

const MobileContainer = styled.div`
  display: none;
  @media (max-width: 800px) {
    width: 100%;
    display: block;
  }
`;

const MobileBOMHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px 10px 0px;
  cursor: pointer;
  border-top: 1px solid #e7e6e6;
  border-bottom: 1px solid #e7e6e6;
`;

const MobileBOMContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  ${props => props.isMobileOpen ? 'max-height: 5000px;' : 'max-height: 0px;overflow: hidden;'}
  transition: max-height 0.3s;
`;

const MobileBOMPadding = styled.div`
  flex: 1 1 0px;
  padding: 10px 0px;
`;

const MobileIconWrapper = styled.div`
  transition: transform 0.3s;
  transform: ${props => props.isMobileOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
`;

const MobileTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1 1 0px;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const MobileIconDownload = styled(Icon)`
`;

const TitleAndModelWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Tag = styled.div`
  display: inline-flex;
  background-color: #CCF1FF;
  color: #005B80;
  font-weight: 400;
  font-size: 14px;
  border-radius: 9999px;
  padding: 5px 10px;
  align-items: center;
`;


class BillOfMaterialsLicence extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobileOpen: false
    }
  }

  static propTypes = {
    softwareLicence: PropTypes.object,
    servicePlanItems: PropTypes.array,
    servicePlanActivated: PropTypes.bool,
    setServicePlanActivation: PropTypes.func,
    isSaving: PropTypes.bool,
    setConfigurationName: PropTypes.func
  }


  renderLicenceTable() {
    let licenceIdx = 1;

    return (
      <TableWrapper>
        <TableLicenceGroupHeader>
          <TableLicenceGroupTitleRow>
            <TableLicenceGroupTitleCell colSpan={5}></TableLicenceGroupTitleCell>
          </TableLicenceGroupTitleRow>
        </TableLicenceGroupHeader>
        <LicencesTableBody>
          {this.props.licenseGroups.map((licenceGroup, idx) => {
            const startIdx = licenceIdx;
            licenceIdx += licenceGroup.licences.length;
            return (<BomLicenceGroup key={idx} licenceGroup={licenceGroup} startIdx={startIdx} licenseModel={this.props.configuration.licenseModel}>L</BomLicenceGroup>); })
          }
          {this.props.servicePlanActivated && (this.props.servicePlanItems || []).length > 0 && <BomServicePlanGroup
            servicePlanItems={this.props.servicePlanItems}
            servicePlanActivated={this.props.servicePlanActivated}
            setServicePlanActivation={this.props.setServicePlanActivation}
            startIdx={licenceIdx}
            isSaving={this.props.isSaving}>
          </BomServicePlanGroup>}
        </LicencesTableBody>
      </TableWrapper>
    )
  }

  _download = () => {
    const now = new Date();
    const rowsData = [];

    const columnSeparator = ';';
    const rows = [];

    let idx = 1;

    this.props.licenseGroups.forEach(licenceGroup => {
      rowsData.push([licenceGroup.name, '', '', '']);
      rowsData.push([I10n.get('bom.order'), I10n.get('bom.licence.reference'), I10n.get('bom.description'), I10n.get('bom.quantity')]);

      licenceGroup.licences.forEach(licence => {
        rowsData.push([idx++, licence.id, ProductInformationCache.getDescription(licence.id) || licence.description, licence.quantity]);
      });
    });

    if (this.props.servicePlanActivated) {
      rowsData.push([I10n.get(`bom.licence.licencegroup.name.service_plan`), '', '', '']);
      rowsData.push([I10n.get('bom.order'), I10n.get('bom.licence.reference'), I10n.get('bom.description'), I10n.get('bom.quantity')]);
      this.props.servicePlanItems.forEach(servicePlanItem => {
        rowsData.push([idx++, servicePlanItem.id, servicePlanItem.description || '', servicePlanItem.quantity]);
      });
    }

    for (const rowData of rowsData) {
      rows.push(rowData.map(d => {
        let escapedData = `${d}`;
        let needsDoubleQuote = false;
        if (escapedData.includes('"')) {
          needsDoubleQuote = true;
          escapedData = escapedData.split('"').join(`""`);
        } else if (escapedData.includes('\n') || escapedData.includes(columnSeparator)) {
          needsDoubleQuote = true;
        }
        return needsDoubleQuote ? `"${escapedData}"` : escapedData;
      }).join(columnSeparator));
    }

    const content = rows.join('\n');
    const dateFormatted = now.toISOString().split('.')[0];

    logCSVEvent(this.props.configuration, this.props.configuration.step);
    download(`${this.props.configuration.name} - ${dateFormatted}.csv`, content);
  }

  render = () => {
    return (
      <>
      <Container>
        <Header>
          <TitleAndModelWrapper>
            <Title>{I10n.get('bom')}</Title>
            {this.props.configuration.softwareInfo?.availableLicenseModels?.length > 1 && <Tag>{I10n.getOrDefault(`screen.licence_selector.license_model.${this.props.configuration.licenseModel}`, this.props.configuration.licenseModel)}</Tag>}
          </TitleAndModelWrapper>
          <ProductsAndIconWrapper desktop={true}>
            <DynamicLabel
              value={this.props.configuration.name}
              setValue={this.props.setConfigurationName}
              enableEdit={!this.props.isSaving}
              withCancel={true}
              customInputProps={{ name: "configurationName", maxLength: "20" }}
            >
            </DynamicLabel>
            {window.top === window.self && this.props.allowBOMFavorites && this.props.isWorkspaceAvailable && !this.props.unifiedCheckoutAvailable && <AddToMyProductWrapper favoritesDisabled={this.props.favoritesDisabled} onClick={() => {
              if (this.props.onAddToFavorites() && !this.props.favoritesDisabled) {
                this.props.onAddToFavorites();
              }
            }}>
            </AddToMyProductWrapper>}
            <Icon title={I10n.get('bom.download')}
              onClick={(e) => {
                e.preventDefault();
                this._download();
              }}
            >
              <MsxIcons option="button" name="download"></MsxIcons>
            </Icon>
          </ProductsAndIconWrapper>
        </Header>
        <LicenceWrapper>
        {this.renderLicenceTable()}
        </LicenceWrapper>
      </Container>
      <MobileContainer isMobileOpen={this.state.isMobileOpen}>
          <MobileBOMHeader onClick={() => { this.setState({ isMobileOpen: !this.state.isMobileOpen }) }}>
            <MobileTitleWrapper>
              <Title>{I10n.get('bom')}
              </Title>
              {this.state.isMobileOpen && <ProductsAndIconWrapper>
                {window.top === window.self && this.props.allowBOMFavorites &&  this.props.isWorkspaceAvailable && !this.props.unifiedCheckoutAvailable && <AddToMyProductWrapper favoritesDisabled={this.props.favoritesDisabled} onClick={(event) => {
                  event.stopPropagation();
                  if (this.props.onAddToFavorites() && !this.props.favoritesDisabled) {
                    this.props.onAddToFavorites();
                  }
                }}>
                  <MsxIcons name="favorites"></MsxIcons>
                  <AddToMyProductLabel>{I10n.get('saved_configuration.export.favorites')}</AddToMyProductLabel>
                </AddToMyProductWrapper>}
                <MobileIconDownload title={I10n.get('bom.download')}
                  onClick={(e) => {
                    e.stopPropagation();
                    this._download();
                  }}
                >
                  <MsxIcons option="button" name="download"></MsxIcons>
                </MobileIconDownload>
              </ProductsAndIconWrapper>}
            </MobileTitleWrapper>
            <MobileIconWrapper isMobileOpen={this.state.isMobileOpen}>
              <MsxIcons name="down-arrow" size="small"></MsxIcons>
            </MobileIconWrapper>
          </MobileBOMHeader>
          <MobileBOMContent isMobileOpen={this.state.isMobileOpen}>
            <MobileBOMPadding>
              {this.renderLicenceTable()}
            </MobileBOMPadding>
          </MobileBOMContent>
        </MobileContainer>
        </>
    );
  }
}

export default BillOfMaterialsLicence;
